import { TrainingInsightFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const useAttendancePct = (insights: TrainingInsightFragment) => {
  const attendancePct = insights.attendancePct

  const attendance = [
    {
      value: attendancePct?.completedAttendancePct || 0,
      label: i18n.t('trainings.insights.charts.average_attendance.completed'),
      originalLabel: i18n.t('trainings.insights.charts.average_attendance.completed'),
      id: '1',
    },
    {
      value: attendancePct?.notStartedAttendancePct || 0,
      label: i18n.t('trainings.insights.charts.average_attendance.not_started'),
      originalLabel: i18n.t('trainings.insights.charts.average_attendance.not_started'),
      id: '2',
    },
    {
      value: attendancePct?.missingAttendancePct || 0,
      label: i18n.t('trainings.insights.charts.average_attendance.missing'),
      originalLabel: i18n.t('trainings.insights.charts.average_attendance.missing'),
      id: '3',
    },
    {
      value: attendancePct?.startedAttendancePct || 0,
      label: i18n.t('trainings.insights.charts.average_attendance.started'),
      originalLabel: i18n.t('trainings.insights.charts.average_attendance.started'),
      id: '4',
    },
    {
      value: attendancePct?.partiallyCompletedAttendancePct || 0,
      label: i18n.t('trainings.insights.charts.average_attendance.partially_completed'),
      originalLabel: i18n.t('trainings.insights.charts.average_attendance.partially_completed'),
      id: '5',
    },
  ]
  return { attendance }
}
